import { Component, OnInit } from '@angular/core';
import { DashboardService } from './services/dashboard.service';
import { PreloginService } from './services/prelogin.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [DashboardService]
})
export class AppComponent implements OnInit {
  isLoggedIn;

  constructor(private preLoginService: PreloginService) { }

  ngOnInit() {
    this.preLoginService.getLoggedInFlagForNav().subscribe(data => {
      this.isLoggedIn = data;
    });

    if (localStorage.getItem('pp_session') != null) {
      this.isLoggedIn = true;
    }
    else {
      this.isLoggedIn = false;
    }
  }

}
